import React from 'react';
import PropTypes from 'prop-types';
import { useModalContext } from 'Views/Page/Contexts/ModalContext';

const NextUpContextContext = React.createContext(undefined);

const NextUpContextProvider = ({
  children,
}) => {
  const { modalCollection, setModalCollection } = useModalContext();

  const handleAccountFundingItemUpdate = React.useCallback(async (fundingItem) => {
    const nextUpReviewResource = modalCollection.resources().head();
    const foundScenario = nextUpReviewResource.attr('proposalScenarioNextUpGroups').resources().list().find((s) => s.attr('facetPlanProposalScenarioId') === fundingItem.attr('facetPlanProposalScenarioId'));

    if (!foundScenario) {
      return;
    }

    const foundAccount = foundScenario.attr('nextUpAccountItems').resources().list().find((a) => a.attr('destinationVirtualAccountID') === fundingItem.attr('destinationVirtualAccountID'));

    if (!foundAccount) {
      return;
    }

    const foundFundingItemIndex = foundAccount.attr('nextUpFundingItems').resources().list().findIndex((f) => f.id() === fundingItem.id());

    if (foundFundingItemIndex === -1) {
      return;
    }

    foundAccount.attr('nextUpFundingItems').resources().replaceAtIndex(foundFundingItemIndex, fundingItem);

    setModalCollection(modalCollection);
  }, [modalCollection]);

  const memoizedValue = React.useMemo(() => {
    const nextUpReviewResource = modalCollection
      ? modalCollection.resources().head()
      : null;

    return {
      nextUpReviewResource,
      handleAccountFundingItemUpdate,
    };
  }, [
    modalCollection,
    handleAccountFundingItemUpdate,
  ]);

  return (
    <NextUpContextContext.Provider value={memoizedValue}>
      {children}
    </NextUpContextContext.Provider>
  );
};

// Use NextUpContext State Context
const useNextUpReviewContext = () => {
  const context = React.useContext(NextUpContextContext);
  if (context === undefined) {
    throw new Error('useNextUpReviewContext must be used within a NextUpContextProvider');
  }
  return context;
};

NextUpContextProvider.propTypes = {
  children: PropTypes.oneOfType([
    PropTypes.node,
    PropTypes.arrayOf(PropTypes.node),
  ]).isRequired,
};

export {
  NextUpContextProvider,
  useNextUpReviewContext,
};
